export enum WorkOrderDrawerTabs {
  Steps = "steps",
  Details = "details",
  History = "history",
  Documents = "documents",
  Activity = "activity",
}
